module.exports = __webpack_public_path__ + "static/media/smepdark.778ff29c.jpeg";